import React, {useState, useEffect} from 'react';
import {StyleSheet, View} from 'react-native';
import {Typography, Badge} from 'src/components';
import {colors} from 'src/assets';
import {OfferAvatar} from 'src/components/offer-list-item/components';
import {IService} from 'src/domains';
import {UserStatus} from 'src/domains';

export type CallOfferProps = {
  offer: IService;
  hideStatus?: boolean;
};

export const CallOffer: React.FC<CallOfferProps> = ({offer, hideStatus}) => {
  const [status, setStatus] = useState<UserStatus>(
    offer.owner?.status || UserStatus.LOGOUT,
  );

  useEffect(() => {
    setStatus(offer.owner?.status || UserStatus.LOGOUT);
  }, [offer]);
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Typography variant={'h1'} text={offer.title || ''} />
        {offer.category?.title ? (
          <Badge
            containerStyle={styles.badge}
            text={offer.category?.title}
            color={colors.chokuGray5}
          />
        ) : null}
      </View>
      <OfferAvatar
        source={offer.mainImageUrl ? {uri: offer.mainImageUrl} : undefined}
        status={!hideStatus ? status : undefined}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: colors.white,
    paddingHorizontal: 16,
    paddingBottom: 12,
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginRight: 24,
  },
  badge: {
    marginTop: 8,
  },
  priceContainer: {
    width: '100%',
    marginTop: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  offerImageContainer: {},
});
